import MicrophoneIcon from '@atlaskit/icon/core/microphone';
import * as React from 'react';

export function SvgMic() {
  return <MicrophoneIcon label="" testId="ads-refreshed-icon" />;
}
